// @flow

import { onlyWhenSupport, type UserInputValidationError, type UserInputValidatorArgs, VALID } from '@tectonics/prs/validation';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { validatePhilippinePhone } from '@tectonics/prs/philippines/validation/philippine-phone';
import { validateCustomerEmail } from '@tectonics/prs/customer/validation/customer-email';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'philippinesPhoneNumber':
      if (!hasOptionalField(optionalFields, 'phone_number')) {
        return onlyWhen('field_philippines_phone_number') && validatePhilippinePhone(userInputValue);
      }
      return null;

    case 'customerEmail':
      return onlyWhen('field_philippines_customer_email') && validateCustomerEmail(userInputValue);


    default:
      return VALID;
  }
}
